import { Component } from "./Component";
import { Model } from "./Concers/Model";

export class Chapter extends Model {
    id: number;
    components: Component[];
    chapters: Chapter[];

    constructor(item) {
        super(item);
        this.components = item.components?.map(
            (component) => new Component(component)
        );
        this.chapters = item.chapters?.map((chapter) => new Chapter(chapter));
    }
}
